import { Grid, Paper, styled } from "@mui/material";
  import React, { useState } from "react";
  import { Button, Col, Form, Row } from "react-bootstrap";
  import BillingReportsService from "../../../Services/Reports/BillingReportsService";
  import Home from "../../home/Home";
  import Snackbar from '../../Snacbar';
  


  const ItemPap = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    border: " 1px solid black",
    // backgroundColor: "#C8EDE7",
    height: "100%",
  }));
 
  
  function BillEdit() {
    const mystyle = {
      border: " 1px solid black",
      width: "10rem", fontFamily: 'Times New Roman',
    };
    const mystyle1 = {
      fontWeight: "bolder",
      color: "#0b64c5", fontFamily: 'Times New Roman',
    };
  
    ///setdetails
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');
    

    const [radiovalue, setradiovalue] = useState("1");
   
    const [showProcs, setshowProcs] = useState(false)
    const [refreshProcs, setrefreshProcs] = useState(false)
    const [dwnldBillCopyProcs, setdwnldBillCopyProcs] = useState(false)
    const [invcpy_values, setinvcpy_values] = useState({
      jobBIllNo: '',
      JOB_DATE:''
    })
    
    const [error, setError] = useState({
      jobBIllNo: false
    })
  
    const [jobno ,setJobNo] = useState('')
    const [billno ,setBillno] = useState('')
  
    // onchange=======>
    const jobBillhandlechange = (e) => {
      setinvcpy_values({ ...invcpy_values, jobBIllNo: e.target.value })
    };
   
    const jobDATEhandlechange=(e)=>{
        setinvcpy_values({ ...invcpy_values, JOB_DATE: e.target.value })
    }
    
    const radiovalueOnchange = (e) => {
      setinvcpy_values({
        ...invcpy_values, jobBIllNo: '', JOB_DATE:''
      });
      
      setradiovalue(e.target.value)
    };
 
    
    //keydown
    const jobNokeydown = (e) => {
      if (e.key === 'Enter') {
        var job_no = '';
        var billN0 =''
        if( !invcpy_values.jobBIllNo || invcpy_values.jobBIllNo===''){
          setError(true);setOpen(true);setMessage('job no/bill no is missing');setseverit('warning');reset();
        }else{
        if(radiovalue==='1'){
          job_no = invcpy_values.jobBIllNo;
           billN0 ='-1'
        }
        else if(radiovalue==='2'){
          job_no = '-1';
           billN0 =invcpy_values.jobBIllNo;
        }
       BillingReportsService.get_bill_edit(job_no,billN0).then((res)=>{

        const data = res.data;

        const BillData = data.map(item=>item)
        setJobNo(BillData[0].job_no)
        setBillno(BillData[0].bill_no)
         setinvcpy_values({ ...invcpy_values,JOB_DATE:BillData[0].job_date });

       }).catch(error=>{
        setOpen(true)
        setMessage(error.message);
        setseverit('error')
       })
      }
      }
    }
  
    //error box
    const handleClose = () => {
      setOpen(false)
    }
  
    const reset=()=>{
      setJobNo('')
      setBillno('')
       setinvcpy_values({ ...invcpy_values,JOB_DATE:'',jobBIllNo:'' });
    }
  
    const removeSecond=()=>{
      if( !jobno || jobno==='' || !billno || billno===''){
        setError(true);setOpen(true);setMessage('job no/bill no is missing');setseverit('warning');
        reset();
      }else{
        setshowProcs(true)
        var job_no = '';
        var billN0 =''
        if(radiovalue==='1'){
          job_no = invcpy_values.jobBIllNo;
           billN0 ='-1'
        }
        else if(radiovalue ==='2'){
          job_no = '-1';
           billN0 =invcpy_values.jobBIllNo;
        }
        let details ={job_no:job_no,bill_no:billN0,job_date:invcpy_values.JOB_DATE}
        BillingReportsService.update_bill_status(details,'1').then((res)=>{

          const messagedate= res.data.message;
  
        setOpen(true);setMessage(messagedate.toString());setseverit('success');reset();
        setshowProcs(false)
         }).catch(error=>{
          setOpen(true)
          setMessage(error.message);
          setseverit('error');  setshowProcs(false);reset();
         })
        }
    }
   const  removeAudit=()=>{
    if( !jobno || jobno==='' || !billno || billno===''){
      setError(true);setOpen(true);setMessage('job no/bill no is missing');setseverit('warning');reset();
    }else{
    setrefreshProcs(true)
    var job_no = '';
    var billN0 =''
    if(radiovalue==='1'){
      job_no = invcpy_values.jobBIllNo;
       billN0 ='-1'
    }
    else if(radiovalue ==='2'){
      job_no = '-1';
       billN0 =invcpy_values.jobBIllNo;
    }
    let details ={job_no:job_no,bill_no:billN0,job_date:invcpy_values.JOB_DATE}
    BillingReportsService.update_bill_status(details,'2').then((res)=>{

      const data = res.data;

      const message = data.message;

    setOpen(true);setMessage(message.toString());setseverit('success');reset();
    setrefreshProcs(false)
     }).catch(error=>{
      setOpen(true)
      setMessage(error.message);
      setseverit('error');  setrefreshProcs(false);reset();
     })
    }
   }

   const  removeTally=()=>{
    if( !jobno || jobno==='' || !billno || billno===''){
      setError(true);setOpen(true);setMessage('job no/bill no is missing');setseverit('warning');reset();
    }else{
    setdwnldBillCopyProcs(true);
    var job_no = '';
    var billN0 =''
    if(radiovalue==='1'){
      job_no = invcpy_values.jobBIllNo;
       billN0 ='-1'
    }
    else if(radiovalue ==='2'){
      job_no = '-1';
       billN0 =invcpy_values.jobBIllNo;
    }
    let details ={job_no:job_no,bill_no:billN0,job_date:invcpy_values.JOB_DATE}
    BillingReportsService.update_bill_status(details,'3').then((res)=>{

      const data = res.data;

      const message = data.message;

    setOpen(true);setMessage(message.toString());setseverit('success');reset();
    setdwnldBillCopyProcs(false)
     }).catch(error=>{
      setOpen(true)
      setMessage(error.message);
      setseverit('error');  setdwnldBillCopyProcs(false);reset();
     })
    }
   }
    
    const gettitle = () => {
      if (radiovalue === '1') {
        return 'Job';
      } else {
        return 'Bill'
      }
    }
  
  

    return (
      <div>
 
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {/* //////////////////////..................input designs.......................... */}
        <Home />
        <div style={{ paddingLeft: '80px' }} className='App'>
         
            <ItemPap >
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '23px', marginTop: '1%', marginBottom: '1%', }}><center>Bill Edit</center></div>
              <Grid container>

                <Grid item xs={8}>
                 
                  <Row>
                  <Col xs={5}></Col>
                    <Col xs={7}>
                      <Form.Check style={mystyle1} checked={radiovalue === '1'} onChange={radiovalueOnchange} inline label='Job No' value={'1'} type='radio' />
                      <Form.Check style={mystyle1} checked={radiovalue === '2'} onChange={radiovalueOnchange} inline label='GST BillNo' value={'2'} type='radio' />
                    </Col>
                  </Row>
                  <br></br>
                  <Row>
                    <Col xs={6}></Col>
                    <Col xs={2}><label style={mystyle1}>{gettitle()} No</label></Col>
                    <Col xs={1}>
                      <Form.Control  size="sm" type="text" id='jobBillId' style={mystyle} onKeyDown={jobNokeydown}
                        value={invcpy_values.jobBIllNo} onChange={jobBillhandlechange} isInvalid={error.jobBIllNo} />
                    </Col>
                  </Row>
                  <Row className="mt-1">
                    <Col xs={6}></Col>
                    <Col xs={2}><label style={mystyle1}>{gettitle()} Date</label></Col>
                    <Col xs={1}>
                      <Form.Control size="sm" style={mystyle} type="date" disabled  value={invcpy_values.JOB_DATE} onChange={jobDATEhandlechange} />
                    </Col>
                  </Row>
                 
                  <Row className="mt-3 mb-2">
                    <Col lg={5}></Col>
                    <Col lg={7}>
                        
                       <Button onClick={removeSecond} style={{ fontFamily: 'Times New Roman' }} disabled={showProcs} size="sm">{showProcs ? 'processing...' : 'REMOVE SECOND Lvl'}</Button>{" "}
                      <Button size="sm" style={{ fontFamily: 'Times New Roman' }} disabled={refreshProcs} onClick={removeAudit}>{refreshProcs ? 'processing...' : 'REMOVE AUDIT'}</Button>{" "}
                      <Button size="sm" style={{ fontFamily: 'Times New Roman' }} disabled={dwnldBillCopyProcs} onClick={removeTally}>{dwnldBillCopyProcs ? 'processing...' : 'REMOVE TALLY'}</Button>
                   
                    </Col>
                    <Col lg={2}></Col>
                  </Row>
                </Grid>
                
              </Grid>
           
            </ItemPap>
          
        </div>
      </div >
    );
  }
  
  export default BillEdit;
  